<banner-app
  [Fixtop]="''"
  [retroSelected]="true"
  [infoDueno]="true"
  [showPromo]="true"
></banner-app>
<div class="final-page__container">
  <div class="final-page__text-container">
    <p class="final-page__text">Lo sentimos :(</p>
    <p class="final-page__text">
      Luego de realizar algunas validaciones, lamentamos decirte que no podemos
      ofrecerte el Seguro de motos de SURA, pues no cumples con nuestras
      políticas internas.
    </p>
  </div>
  <div class="final-page__image-container">
    <img
      src="./assets/img/no-pasa-sarlaft.png"
      class="final-page__image"
      alt="Imagen de no pasa SARLAFT"
      loading="lazy"
    />
  </div>
  <div class="final-page__button-container">
    <button class="final-page__button" (click)="redirect()">Ir a Sura.co</button>
  </div>
</div>

<app-footer-app class="footer-fixed" />